/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Place } from '../model/place';
import { PlaceData } from '../model/placeData';
import { PlacePagination } from '../model/placePagination';
import { PlacePatch } from '../model/placePatch';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PlaceServiceInterface }                            from './place.serviceInterface';


@Injectable()
export class PlaceService implements PlaceServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve all Place resources.
     * 
     * @param x_keyclic_app 
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param business_activity The identifier of the resource formatted as GUID string.
     * @param geo_coordinates One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param geo_elevation 
     * @param geo_hash 
     * @param geo_point One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param organization The identifier of the resource formatted as GUID string.
     * @param parent The identifier of the resource formatted as GUID string.
     * @param parents The identifier of the resource formatted as GUID string.
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_branchCode 
     * @param search_name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetPlaces(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, organization?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'body', reportProgress?: boolean): Observable<PlacePagination>;
    public cgetPlaces(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, organization?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlacePagination>>;
    public cgetPlaces(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, organization?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlacePagination>>;
    public cgetPlaces(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, organization?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetPlaces.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (business_activity !== undefined && business_activity !== null) {
            queryParameters = queryParameters.set('business_activity', <any>business_activity);
        }
        if (geo_coordinates !== undefined && geo_coordinates !== null) {
            queryParameters = queryParameters.set('geo_coordinates', <any>geo_coordinates);
        }
        if (geo_elevation !== undefined && geo_elevation !== null) {
            queryParameters = queryParameters.set('geo_elevation', <any>geo_elevation);
        }
        if (geo_hash !== undefined && geo_hash !== null) {
            queryParameters = queryParameters.set('geo_hash[]', <any>geo_hash);
        }
        if (geo_point !== undefined && geo_point !== null) {
            queryParameters = queryParameters.set('geo_point', <any>geo_point);
        }
        if (organization !== undefined && organization !== null) {
            queryParameters = queryParameters.set('organization', <any>organization);
        }
        if (parent !== undefined && parent !== null) {
            queryParameters = queryParameters.set('parent', <any>parent);
        }
        if (parents !== undefined && parents !== null) {
            queryParameters = queryParameters.set('parents[]', <any>parents);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_branchCode !== undefined && search_branchCode !== null) {
            queryParameters = queryParameters.set('search[branchCode]', <any>search_branchCode);
        }
        if (search_name !== undefined && search_name !== null) {
            queryParameters = queryParameters.set('search[name]', <any>search_name);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<PlacePagination>(`${this.basePath}/places`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve all Place resources.
     * 
     * @param x_keyclic_app 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param business_activity The identifier of the resource formatted as GUID string.
     * @param geo_coordinates One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param geo_elevation 
     * @param geo_hash 
     * @param geo_point One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param parent The identifier of the resource formatted as GUID string.
     * @param parents The identifier of the resource formatted as GUID string.
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_branchCode 
     * @param search_name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetPlacesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'body', reportProgress?: boolean): Observable<PlacePagination>;
    public cgetPlacesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlacePagination>>;
    public cgetPlacesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlacePagination>>;
    public cgetPlacesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_elevation?: string, geo_hash?: string, geo_point?: string, parent?: string, parents?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_branchCode?: string, search_name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetPlacesByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling cgetPlacesByOrganization.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (business_activity !== undefined && business_activity !== null) {
            queryParameters = queryParameters.set('business_activity', <any>business_activity);
        }
        if (geo_coordinates !== undefined && geo_coordinates !== null) {
            queryParameters = queryParameters.set('geo_coordinates', <any>geo_coordinates);
        }
        if (geo_elevation !== undefined && geo_elevation !== null) {
            queryParameters = queryParameters.set('geo_elevation', <any>geo_elevation);
        }
        if (geo_hash !== undefined && geo_hash !== null) {
            queryParameters = queryParameters.set('geo_hash[]', <any>geo_hash);
        }
        if (geo_point !== undefined && geo_point !== null) {
            queryParameters = queryParameters.set('geo_point', <any>geo_point);
        }
        if (parent !== undefined && parent !== null) {
            queryParameters = queryParameters.set('parent', <any>parent);
        }
        if (parents !== undefined && parents !== null) {
            queryParameters = queryParameters.set('parents[]', <any>parents);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_branchCode !== undefined && search_branchCode !== null) {
            queryParameters = queryParameters.set('search[branchCode]', <any>search_branchCode);
        }
        if (search_name !== undefined && search_name !== null) {
            queryParameters = queryParameters.set('search[name]', <any>search_name);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<PlacePagination>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/places`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve one Place resource.
     * 
     * @param x_keyclic_app 
     * @param place The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlace(x_keyclic_app: string, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Place>;
    public getPlace(x_keyclic_app: string, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Place>>;
    public getPlace(x_keyclic_app: string, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Place>>;
    public getPlace(x_keyclic_app: string, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling getPlace.');
        }
        if (place === null || place === undefined) {
            throw new Error('Required parameter place was null or undefined when calling getPlace.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<Place>(`${this.basePath}/places/${encodeURIComponent(String(place))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edit one Place resource.
     * 
     * @param x_keyclic_app 
     * @param PlacePatch 
     * @param place The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchPlace(x_keyclic_app: string, PlacePatch: PlacePatch, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Place>;
    public patchPlace(x_keyclic_app: string, PlacePatch: PlacePatch, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Place>>;
    public patchPlace(x_keyclic_app: string, PlacePatch: PlacePatch, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Place>>;
    public patchPlace(x_keyclic_app: string, PlacePatch: PlacePatch, place: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling patchPlace.');
        }
        if (PlacePatch === null || PlacePatch === undefined) {
            throw new Error('Required parameter PlacePatch was null or undefined when calling patchPlace.');
        }
        if (place === null || place === undefined) {
            throw new Error('Required parameter place was null or undefined when calling patchPlace.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<Place>(`${this.basePath}/places/${encodeURIComponent(String(place))}`,
            PlacePatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create one Place resource.
     * 
     * @param x_keyclic_app 
     * @param PlaceData 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postPlaceByOrganization(x_keyclic_app: string, PlaceData: PlaceData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Place>;
    public postPlaceByOrganization(x_keyclic_app: string, PlaceData: PlaceData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Place>>;
    public postPlaceByOrganization(x_keyclic_app: string, PlaceData: PlaceData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Place>>;
    public postPlaceByOrganization(x_keyclic_app: string, PlaceData: PlaceData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling postPlaceByOrganization.');
        }
        if (PlaceData === null || PlaceData === undefined) {
            throw new Error('Required parameter PlaceData was null or undefined when calling postPlaceByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling postPlaceByOrganization.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Place>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/places`,
            PlaceData,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
